var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var ModelAdderModel = function (root) {
    lib_core.Model.apply(this);
    
    var self = this;
    this.model3dAsset = null;
    //this.model3d3JSObject = this.value("model3d3JSObject", true);

    this.makeModelPublicModalShown = this.value("makeModelPublicModalShown", true);

};

lib_core.inherit(ModelAdderModel, lib_core.Model);
lib_core.JsonParser.registerClass(ModelAdderModel, "ModelAdderModel");

module.exports = ModelAdderModel;
